import { EventEmitter } from "@angular/core";
import {
  ChannelPermissonNames,
  RawUser,
  RoleNames,
  User,
  UserChannelPermission,
} from "../../../domain/user";
import { Tenant } from "../../../domain/tenant";
import { NgForm } from "@angular/forms";
import moment from "moment";
import { ancestorWhere } from "tslint";
import { Channel } from "../../../domain/channel";
export class ChannelPermissionsVM {
  constructor(
    public channelId: number,
    public channelName: string,
    public tenantName: string,
    public view: boolean = false,
    public editSchedule: boolean = false,
    public editSettings: boolean = false,
    public activateDeactivateChannel: boolean = false,
  ) {}
}
export class ChannelVM {
  constructor(
    public channelId: number,
    public channelName: string,
    public tenantId: number,
    public tenantName,
  ) {}
}
export class EditUserViewModel {
  public editableUserBeforeChanges: RawUser;
  private personalDetailsForm: NgForm;
  public confirmPasswordFieldValue = "";
  public passwordFieldValue = "";
  public channelPermissionsVMs: ChannelPermissionsVM[] = [];
  public loading = false;
  public allManagedTenants: Tenant[] = [];

  public applyClicked = new EventEmitter<void>();
  public userPasswordChanged = new EventEmitter<string>(false);
  public twoFactowWasReset = new EventEmitter<void>();
  public channelPermissionSwitcher = {};
  public allManagedChannels: ChannelVM[] = [];

  constructor(
    public currentUser: User,
    public editableUser: RawUser,
    public allTenants: Array<Tenant>,
    public allActionPermissionVMs: Array<{
      displayTitle: string;
      value: string;
    }>,
    public showPasswordFields: boolean,
    public showResetPasswordButton: boolean,
    public showReseTwoFactorButton: boolean,
    public validateUsernameExistsOnServer: (username) => Promise<boolean>,
    public getChannelsByTenantId: (tenantId: number) => Promise<Array<Channel>>,
    public createNewTenantOnServer: (tenantName) => Promise<Tenant>,
    public choosenTab = "personal",
  ) {
    this.editableUserBeforeChanges = editableUser.clone();
    console.log(
      "edit-user-vm->currentUser.managedTenantIds",
      currentUser.managedTenantIds,
    );
    this.allManagedTenants = [
      ...this.allTenants.filter((t) =>
        currentUser.managedTenantIds.includes(t.id),
      ),
    ];
  }

  public resetChanges() {
    this.editableUser = this.editableUserBeforeChanges.clone();
    this.initChannelPermissions().then();
    this.channelPermissionSwitcher = {};

    this._resetFormControls();
  }

  public async initChannelPermissions() {
    this.loading = true;

    this.allManagedChannels = await this._getChannelsByTenantIds(
      this.editableUser.managedTenantIds,
    );
    this.channelPermissionsVMs = this.initChannelPermissionsVMs();

    this.loading = false;
  }

  setPersonalDetailsForm(personalDetailsForm: NgForm) {
    this.personalDetailsForm = personalDetailsForm;
  }

  verifyPersonalDetailsFormField(
    fieldName: string,
    validatorName: string,
  ): boolean {
    return !(
      this.personalDetailsForm.controls[fieldName] &&
      this.personalDetailsForm.controls[fieldName].touched &&
      this.personalDetailsForm.controls[fieldName].errors &&
      this.personalDetailsForm.controls[fieldName].errors[validatorName]
    );
  }

  checkDateFormat(date: Date) {
    return moment(date).format("YYYY-MM-DD");
  }

  async onTenantDropdownChange(value) {
    this.allManagedChannels = await this._getChannelsByTenantIds(
      this.editableUser.managedTenantIds,
    );
    console.log(
      "edit-user-vm->onTenantDropdownChange",
      this.editableUser.managedTenantIds,
      this.allManagedChannels,
    );
    this.channelPermissionsVMs = this.initChannelPermissionsVMs();
  }

  onPersonalDetailsFormSubmit() {
    if (this.personalDetailsForm.valid) {
      this.applyChanges();
    } else {
      Object.keys(this.personalDetailsForm.controls).forEach((field) => {
        const control = this.personalDetailsForm.controls[field];
        control.markAsTouched({ onlySelf: true });
      });
    }
  }

  togglePermissionOnAllChannels(permissionName: string) {
    if (!this.channelPermissionSwitcher[permissionName]) {
      this.channelPermissionSwitcher[permissionName] = false;
    }
    this.channelPermissionSwitcher[permissionName] =
      !this.channelPermissionSwitcher[permissionName];
    this.allManagedChannels.forEach((channel) =>
      this.setChannelPermission(
        channel.channelId,
        permissionName,
        this.channelPermissionSwitcher[permissionName],
      ),
    );
  }
  setChannelPermission(
    channelId: number,
    permissionName: string,
    value: boolean,
  ) {
    if (!this.editableUser.channelPermissions[channelId]) {
      this.editableUser.channelPermissions[channelId] =
        new UserChannelPermission(channelId);
    }
    this.editableUser.channelPermissions[channelId][permissionName] = value;

    const channelPermission = this.channelPermissionsVMs.find(
      (p) => p.channelId === channelId,
    );

    if (
      value === true &&
      permissionName === ChannelPermissonNames.editSchedule
    ) {
      this.setChannelPermission(channelId, ChannelPermissonNames.view, value);

      channelPermission.view = value;
    }

    if (value === false && permissionName === ChannelPermissonNames.view) {
      this.setChannelPermission(
        channelId,
        ChannelPermissonNames.editSchedule,
        value,
      );

      channelPermission.editSchedule = false;
    }
    channelPermission[permissionName] = value;
  }

  updateTrialDateEventHandler($event) {
    let updatedDate: Date = null;

    if ($event.target.value.length > 0) {
      updatedDate = moment($event.target.value).toDate();
    }

    this.editableUser.trialEndsDate = updatedDate;
  }

  async createNewTenant() {
    const newTenantName = window.prompt("Choose Tenant Name");

    if (newTenantName && newTenantName.length > 0) {
      const newTenant = await this.createNewTenantOnServer(newTenantName);
      this.allTenants.push(newTenant);

      alert(`Tenant  was created successfully!\nGUID: ${newTenant.uid}`);
    }

    return false;
  }

  async validateEmailExists(email: string) {
    if (this.personalDetailsForm.controls["username"].valid) {
      const result = await this.validateUsernameExistsOnServer(email);

      const control = this.personalDetailsForm.controls["username"];
      if (result) {
        control.setErrors({ usernameExists: true });
      } else {
        control.setErrors(null);
      }
      control.markAsTouched({ onlySelf: true });
    }
  }

  resetPassword() {
    const newPassword = window.prompt("Please enter a new password");
    if (
      newPassword &&
      /(?=^.{6,}$)(?=.*\d)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/gm.test(
        newPassword,
      )
    ) {
      const confirmPassword = window.prompt("Please confirm the password");
      if (confirmPassword) {
        if (newPassword === confirmPassword) {
          this.userPasswordChanged.emit(newPassword);
          alert("Password was changed successfully!");
        } else {
          alert("Password mismatch!!");
        }
      }
    } else {
      // tslint:disable-next-line:max-line-length
      alert(
        "Wrong password!\n\n * The password length must be greater than or equal to 6 \n * The password must contain one or more uppercase characters \n * The password must contain one or more lowercase characters \n * The password must contain one or more numeric values",
      );
    }
  }

  reset2FA() {
    console.log("user state", this.editableUser);
    if (
      window.confirm(
        "Are you sure you want to reset the two factor authentication of user " +
          this.editableUser.email +
          "?",
      )
    ) {
      this.twoFactowWasReset.emit();
      this.editableUserBeforeChanges = this.editableUser;
      alert("Two Factor has been reset!");
    }
  }

  resetUserTrial() {
    this.editableUser.trialEndsDate = null;
  }

  applyChanges() {
    this.editableUserBeforeChanges = this.editableUser.clone();
    console.log("edit-user-vm->applyChanges", this.editableUserBeforeChanges);
    this.applyClicked.emit();
  }

  private initChannelPermissionsVMs(): ChannelPermissionsVM[] {
    return this.allManagedChannels.map((managedChannel: ChannelVM) => {
      const canView = this.editableUser.hasViewSchedulerPermission({
        id: managedChannel.channelId,
        isBlock: false,
      } as Channel);
      const canEditSchedule = this.editableUser.hasEditSchedulePermission({
        id: managedChannel.channelId,
        isBlock: false,
      } as Channel);
      const canEditSettings =
        this.editableUser.hasEditChannelSettingsPermission({
          id: managedChannel.channelId,
          isBlock: false,
        } as Channel);
      const canActivateDeactivateChannel =
        this.editableUser.hasActivateDeactivateChannelPermission({
          id: managedChannel.channelId,
          isBlock: false,
        } as Channel);
      const channelPermissionVM = new ChannelPermissionsVM(
        managedChannel.channelId,
        managedChannel.channelName,
        managedChannel.tenantName,
        canView,
        canEditSchedule,
        canEditSettings,
        canActivateDeactivateChannel,
      );
      console.log("new permission vm: ", channelPermissionVM);
      return channelPermissionVM;
    });
  }
  private async _getChannelsByTenantIds(
    tenantIds: number[],
  ): Promise<ChannelVM[]> {
    const result = [];

    for (let i = 0; i < tenantIds.length; i++) {
      const currentTenantId = tenantIds[i];
      const currentTenant = this.allTenants.find(
        (t) => t.id === currentTenantId,
      );
      const managedChannels = await this.getChannelsByTenantId(tenantIds[i]);
      result.push(
        ...managedChannels.map(
          (channel) =>
            new ChannelVM(
              channel.id,
              channel.name,
              currentTenantId,
              currentTenant.name,
            ),
        ),
      );
    }

    return result;
  }

  private _resetFormControls() {
    const formControls = this.personalDetailsForm.controls;
    for (const controlName in formControls) {
      const control = formControls[controlName];
      const value = this.editableUser[controlName];
      control.reset(value);
    }
  }
}
